"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
class DependencyBase extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.dependency = () => { };
    }
}
exports.default = DependencyBase;
_a = DependencyBase;
DependencyBase.dependency = () => _a._componentDependencies.every((dependency) => dependency());
DependencyBase.onScriptLoaded = () => { };
DependencyBase._componentDependencies = [];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVwZW5kZWN5QmFzZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZXBlbmRlbmNpZXMvRGVwZW5kZWN5QmFzZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxpQ0FBc0M7QUFFdEMsTUFBOEIsY0FBcUIsU0FBUSxxQkFBYTtJQUF4RTs7UUFJVyxlQUFVLEdBQUcsR0FBRyxFQUFFLEdBQUUsQ0FBQyxDQUFDO0lBQ2pDLENBQUM7O0FBTEQsaUNBS0M7O0FBSmlCLHlCQUFVLEdBQUcsR0FBRyxFQUFFLENBQUMsRUFBSSxDQUFDLHNCQUFzQixDQUFDLEtBQUssQ0FBQyxDQUFDLFVBQVUsRUFBRSxFQUFFLENBQUMsVUFBVSxFQUFFLENBQUMsQ0FBQztBQUNuRiw2QkFBYyxHQUFHLEdBQUcsRUFBRSxHQUFFLENBQUMsQ0FBQztBQUNqQyxxQ0FBc0IsR0FBaUIsRUFBRSxDQUFDIn0=